import { render, staticRenderFns } from "./AdminFormPage.vue?vue&type=template&id=16356fc4&scoped=true&"
import script from "./AdminFormPage.vue?vue&type=script&lang=js&"
export * from "./AdminFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16356fc4",
  null
  
)

export default component.exports